import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';

import MainPagetitle from '../../layouts/MainPagetitle';
import PaymentDetailService from '../../api/services/PaymentDetailService';
import { Modal, Button } from 'react-bootstrap';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import AdminPdfprotocolService from '../../api/services/AdminPdfprotocolService';
const EditDocument = () => {
    var imageUrl = process.env.REACT_APP_LARAVEL_IMAGE_URL;
    const params = useParams();
    const navigate = useNavigate();
    const [Pdfupdate, setPdfupdate] = useState(false);
    const [Pdfshow, setPdfprotocolshow] = useState([]);
    const [file, setFile] = useState()
    const [error, setError] = useState([]); 
    const [isLoading, setisloading] = useState(true);
    const [GetFilename, setFilename] = useState(true);
    
    
    useEffect(() => {
        if (localStorage.getItem("admintoken")) {
            var id = params.id;
            getPdfprotocolshow(id);
        }
        else {
            navigate('/')
        }
    }, []);

    const getPdfprotocolshow = async (id) => {
        try {
            let responseshow = await AdminPdfprotocolService.show(id).json(); 
            setPdfprotocolshow(responseshow.data); 
            setisloading(false);
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }
    };

    const onFileChange = (e) => {
        const selectedFile = e.target.files[0];  
       
        const fileName = selectedFile.name.split('.').slice(0, -1).join('.');
        setFilename(fileName);
        
        if (selectedFile) {
            // Validate the file type
            const isPDF = selectedFile.type === 'application/pdf' || selectedFile.name.endsWith('.pdf');
            const fileSizeMB = selectedFile.size / (1024 * 1024); // Convert size to MB

            if (!isPDF) {
                setError("Please upload a valid PDF file.");
                // setIsSubmitEnabled(false);
                e.target.value = null;  
                return;  
            }

            if (fileSizeMB > 10) {
                setError("File size exceeds the maximum limit of 10MB.");
                // setIsSubmitEnabled(false);
                e.target.value = null;  
                return;  
            }

            // If validations pass, read file as Data URL
            const fileReader = new FileReader();

            fileReader.onload = () => {
                const base64String = fileReader.result.split(',')[1]; 
                setFile(base64String); 
                setError(""); 
                // setIsSubmitEnabled(true); 
            };

            fileReader.onerror = (error) => {
                console.error("FileReader error:", error);
                setError("Error reading file.");
                // setIsSubmitEnabled(false);
                e.target.value = null;  
            };

            fileReader.readAsDataURL(selectedFile);
        } else {
            setError("No file selected.");
            setFile(null); 
            e.target.value = null;  
            // setIsSubmitEnabled(false); 
        }
    };
    const onSubmitForm = async (event) => {
        event.preventDefault();
        setError("")
        setisloading(true); 
        try {
            var pdfname = event.target.pdfname.value
            var userData = {               
                "user_id": Pdfshow.user_id, 
                "pdfname":pdfname ? pdfname : GetFilename,  
                "pdf": file,  
            } 
            let responseData = await AdminPdfprotocolService.update(params.id,userData).json()
           
            if (responseData.status === true) { 
                setPdfupdate(true);
                setisloading(false);
            }
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message)
            }
        }

    };

    return (
        <>
            <MainPagetitle mainTitle="Edit Pdf" pageTitle={'Edit Pdf'} parentTitle={'Home'} />
            <div className="container-fluid">
                <form className="form-valide" onSubmit={onSubmitForm}>
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title">Edit Pdf</h4>
                                </div>
                                <div className="card-body">
                                    <div className="row"> 
                                        
                                            <div className="col-xl-6 mb-3">
                                                <label htmlFor="val-number" className="form-label"> PDF Name </label> 
                                                <input 
                                                type="text" 
                                                className="form-control" 
                                                name="pdfname"  
                                                Value={Pdfshow.pdfname ? Pdfshow.pdfname : GetFilename}
                                            />
                                             </div>
                                             <div className="col-xl-6 mb-3"> 
                                            <label htmlFor="val-number" className="form-label"> Pdf upload  
                                                </label> 
                                                <input 
                                                type="file" 
                                                className="form-control" 
                                                name="pdf" 
                                                id="val-number" 
                                                accept=".pdf, application/pdf" 
                                                onChange={onFileChange} 
                                            />
                                        </div> 
                                        <h5 className="mt-2" style={{ color: 'red' }}>{error}</h5>
                                    </div> 
                                    <div>
                                        <button type="submit" className="btn btn-primary me-1">Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </form>
            </div>
            {isLoading && <LogoAnimationLoader />}
             <Modal centered className="mark-attendence" show={Pdfupdate}>
                <Modal.Header>
                    <Modal.Title>Update </Modal.Title>
                    <Button variant="" className="btn-close" onClick={() => setPdfupdate(false)}></Button>
                </Modal.Header>
                <Modal.Body>Update Document Successfully!!!.</Modal.Body>
                <Modal.Footer>
                    <Link className="btn btn-primary" to={`/admin/pdfprotocol/${Pdfshow.user_id}`} variant="danger light" onClick={() => setPdfupdate(false)}>Close</Link>
                </Modal.Footer>
            </Modal>
     
        </>
    );
};
export default EditDocument;